// extracted by mini-css-extract-plugin
export default {"navlinks":"NavBar_navlinks__V19Dw","active":"NavBar_active__tscSN"};